"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlCardAssignmentAction = exports.IlCompletedActionAssignmentCardArgs = exports.IlOverdueScoreActionAssignmentCardArgs = exports.IlOverduedActionAssignmentCardArgs = exports.IlDefaultActionAssignmentCardArgs = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_card_group_assignment_1 = require("../il-card-group-assignment/il-card-group-assignment");
var il_course_card_1 = require("../il-course-card/il-course-card");
var IlDefaultActionAssignmentCardArgs = {
    assignmentType: enums_1.AssignmentTypeEnum.LESSON,
    courseTitle: 'World Geography',
    assignmentTitle: 'Geographic Themes: Location and Place and Place and Location',
    assignmentState: enums_1.AssignmentStateEnum.ACTIVE,
    dueDate: new Date(2023, 2, 15),
    dateToday: new Date(2023, 2, 10),
    sequence: 1,
};
exports.IlDefaultActionAssignmentCardArgs = IlDefaultActionAssignmentCardArgs;
var IlOverduedActionAssignmentCardArgs = {
    assignmentType: enums_1.AssignmentTypeEnum.LESSON,
    courseTitle: 'World Geography',
    assignmentTitle: 'Geographic Themes: Location and Place and Place and Location',
    assignmentState: enums_1.AssignmentStateEnum.OVERDUE,
    dueDate: new Date(2023, 2, 15),
    dateToday: new Date(2023, 2, 10),
    sequence: 1,
};
exports.IlOverduedActionAssignmentCardArgs = IlOverduedActionAssignmentCardArgs;
var IlOverdueScoreActionAssignmentCardArgs = {
    assignmentType: enums_1.AssignmentTypeEnum.LESSON,
    courseTitle: 'World Geography',
    assignmentTitle: 'Geographic Themes: Location and Place and Place and Location',
    assignmentState: enums_1.AssignmentStateEnum.OVERDUE,
    dueDate: new Date(2023, 2, 15),
    dateToday: new Date(2023, 2, 10),
    scoreMessage: 'Score 5/30',
    sequence: 1,
};
exports.IlOverdueScoreActionAssignmentCardArgs = IlOverdueScoreActionAssignmentCardArgs;
var IlCompletedActionAssignmentCardArgs = {
    assignmentType: enums_1.AssignmentTypeEnum.LESSON,
    courseTitle: 'World Geography',
    assignmentTitle: 'Geographic Themes: Location and Place and Place and Location',
    assignmentState: enums_1.AssignmentStateEnum.COMPLETED,
    dueDate: new Date(2023, 2, 15),
    scoreMessage: 'Score 25/30',
    sequence: 1,
};
exports.IlCompletedActionAssignmentCardArgs = IlCompletedActionAssignmentCardArgs;
function IlCardAssignmentAction(props) {
    return (react_1.default.createElement(material_1.Box, null,
        react_1.default.createElement(il_course_card_1.ILCourseCard, __assign({}, props, { sx: __assign({ boxShadow: 'unset', borderRadius: 0, borderBottomWidth: 0, borderTopLeftRadius: '0.375rem', borderTopRightRadius: '0.375rem', '& .MuiCardContent-root': {
                    border: '0.0625rem solid',
                    borderColor: 'action.disabledBackground',
                    borderRadius: 0,
                    borderBottomWidth: 0,
                    borderTopLeftRadius: '0.375rem',
                    borderTopRightRadius: '0.375rem',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                }, '& .MuiCard-root': {
                    borderRadius: 0,
                    borderBottomWidth: 0,
                    borderTopLeftRadius: '0.375rem',
                    borderTopRightRadius: '0.375rem',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                } }, props.sx), onClick: undefined })),
        react_1.default.createElement(il_card_group_assignment_1.IlCardGroupAssignment, __assign({}, props, { sx: __assign({ bgcolor: 'background.default', maxWidth: '100%', '&:hover': {}, borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTopWidth: 0 }, props.sx), overrideChildSx: __assign({ bgcolor: 'background.default' }, props.overrideChildSx) }))));
}
exports.IlCardAssignmentAction = IlCardAssignmentAction;
